import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CdnApiService } from '../../core/cdn';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'app-cdn-card',
  templateUrl: './cdn-card.component.html',
  styleUrls: ['./cdn-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CdnCardComponent implements OnInit {
  cdnEnabled$: Observable<boolean>;
  disableButton$: Observable<boolean>;
  toggleStatusKey$: Observable<string>;

  constructor(
    private cdnService: CdnApiService,
    public readonly analyticsService: ProductAnalyticsService,
  ) {
    this.cdnEnabled$ = this.cdnService.getCdnState$().pipe(map((cdnState) => cdnState.enabled));
    this.disableButton$ = this.cdnService.getLoading$();
    this.toggleStatusKey$ = this.cdnEnabled$.pipe(
      map((cdnEnabled) => (cdnEnabled ? 'CDN_CARD.CDN_ON' : 'CDN_CARD.CDN_OFF')),
    );
  }

  ngOnInit(): void {
    this.cdnService.loadCdnState();
  }

  toggleVal(checked: boolean): void {
    this.analyticsService.trackEvent('home-page:cdn-toggle', 'cdn-toggle', checked ? 'enabled' : 'disabled');
    this.cdnService.setCdn(checked);
  }
}
